import { render, staticRenderFns } from "./ContactForm.vue?vue&type=template&id=a6642518&scoped=true&"
var script = {}
import style0 from "./ContactForm.vue?vue&type=style&index=0&id=a6642518&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6642518",
  null
  
)

export default component.exports